// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"durationbar_wrapper__2KaNe","durationBar":"durationbar_durationBar__HX12V","durationBarComplete":"durationbar_durationBarComplete__1LajM"};